module.exports = __webpack_public_path__ + "static/media/Image_5.a858c080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureBlock/images/Image_5.jpg
// module id = 850
// module chunks = 0